import { useContext } from 'react';
import StepperContext from '../contexts/stepper';
export type { TypePlaceData } from '../contexts/stepper';

const useStepper = () => useContext(StepperContext);

export default useStepper;
